
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/mt1",
      function () {
        return require("private-next-pages/products/mt1/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/mt1"])
      });
    }
  